import React from 'react';

function sanitize(value) {
    if (value === null || value === undefined) return '—';
    if (typeof value === 'number' && isNaN(value)) return '—';
    if (typeof value === 'string' && /^nan/i.test(value.trim())) return '—';
    return value;
}

export default function Aggregate({ label, metric, query }) {

    const { data: queryData, isLoading } = query;

    if (isLoading) {
        return <></>
    }

    const data = queryData.data

    return (
        <div className="aggregate">
            <span className="label">{label}</span>
            <span className="value">{sanitize(data[metric])}</span>
        </div>
    )
}
